import React from 'react';
import { useTranslation } from 'react-i18next';

import { ElementObj } from '../../../../../viewer/elements/element-obj';
import { publish, SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { Icon } from '../../../icon/icon';

export const MoveIcon = (props: { disabled?: boolean; asset: ElementObj }) => {
  const { t } = useTranslation();

  return (
    <Icon
      disabled={props.disabled}
      fixedWidth={true}
      icon={['fal', 'arrows-up-down-left-right']}
      mouseDownStyle={{ opacity: 0.5 }}
      stopPropagationOnClick={true}
      title={t('common.assetHeaderIcons.move', { ns: 'skyviewAssetMenu' })}
      onClick={() => {
        publish(SubscriptionTopic.ShowSetAssetCoordinateDialog, {
          asset: props.asset,
        });
      }}
      onHoverStyle={{ icon: ['fad', 'arrows-up-down-left-right'] }}
    />
  );
};
